import React from "react";
import Icon from "./Icon";

function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    const now = new Date();
    const diff = now - date;
    if (diff < 3600000) return Math.floor(diff / 60000) + " min ago";
    if (diff < 86400000) return Math.floor(diff / 3600000) + "h ago";
    if (diff < 604800000) return Math.floor(diff / 86400000) + "d ago";
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch { return ""; }
}

function getFileColor(type, ext) {
  if (type === "folder") return "folder";
  const e = (ext || "").toLowerCase();
  if (e === "pdf") return "pdf";
  if (["doc", "docx"].includes(e)) return "doc";
  if (["xls", "xlsx", "csv"].includes(e)) return "xls";
  if (["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(e)) return "img";
  if (["py", "js", "ts", "java", "cpp", "c"].includes(e)) return "code";
  if (["ppt", "pptx"].includes(e)) return "ppt";
  if (["zip", "rar", "7z", "tar", "gz"].includes(e)) return "zip";
  return "file";
}

function getExtBadge(ext) {
  if (!ext) return null;
  return ext.toUpperCase();
}

function getIconName(type, ext) {
  if (type === "folder") return "folder";
  const e = (ext || "").toLowerCase();
  if (["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(e)) return "image";
  return "file";
}

function FileGridView({ files, currentPath, onNavigate, onFileClick, onContextMenu }) {
  const handleClick = (item) => {
    if (onFileClick) onFileClick(item);
    else if (item.type === "folder") {
      const path = currentPath === "/" ? `/${item.name}` : `${currentPath}/${item.name}`;
      onNavigate(path);
    }
  };

  // Single unified list: folders first, then files
  const sorted = [
    ...files.filter((f) => f.type === "folder"),
    ...files.filter((f) => f.type !== "folder"),
  ];

  return (
    <div className="gd-grid-wrap">
      <div className="gd-grid">
        {sorted.map((item, i) => {
          const colorClass = getFileColor(item.type, item.ext);
          const extBadge = item.type !== "folder" ? getExtBadge(item.ext) : null;

          return (
            <div
              key={`${item.name}-${i}`}
              className={`gd-grid-card ${colorClass}`}
              data-file-id={item.id}
              onClick={() => handleClick(item)}
              onContextMenu={(e) => onContextMenu(e, item)}
            >
              {/* Preview area */}
              <div className={`gd-grid-card-preview ${colorClass}`}>
                <Icon name={getIconName(item.type, item.ext)} size={item.type === "folder" ? 36 : 30} />
                {extBadge && <span className={`gd-grid-ext ${colorClass}`}>{extBadge}</span>}
                <button
                  className="gd-grid-kebab"
                  onClick={(e) => { e.stopPropagation(); onContextMenu(e, item); }}
                >
                  <Icon name="more" size={14} />
                </button>
              </div>

              {/* Info area */}
              <div className="gd-grid-card-info">
                <div className="gd-grid-card-name" title={item.name}>{item.name}</div>
                <div className="gd-grid-card-meta">
                  {item.type === "folder"
                    ? formatDate(item.modified)
                    : [item.size, formatDate(item.modified)].filter(Boolean).join(" \u00b7 ")}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FileGridView;
